import { useState } from 'react'
import { useSelector } from 'react-redux'
import { IprAttDesktop } from 'Ui/Components/iprAtt/IprAttDesktop'

/*****************************************************************
 * TOOTH ATTACHMENT IN BOTTOM PANEL
 * ***************************************************************/

const
    section = [
        'CURRENT',
        'TOTAL'
    ],
    teeth = {
        tpUpper: [18,17,16,15,14,13,12,11,21,22,23,24,25,26,27,28],
        tpLower: [48,47,46,45,44,43,42,41,31,32,33,34,35,36,37,38]
    },
    spe = {
        att: [
            'attachmentPos',
            'attachmentNeg',
            'button'
        ],
        ipr: [
            'mesial',
            'distal'
        ]
    }


/**
 * Component iprAtt specification
 * @params {object} - react props
 * @returns {JSX} - return desktop components
 */
export const IprAtt = props => {

    const
        getJawType = props => {
            let merge = props.att.concat(props.ipr).filter( (value, index, self) => self.indexOf(value) === index )
            for (let i = 0; i < merge.length; i++) {
                if(merge[i] === 'both'){
                    merge.splice( i, 1, 'tpUpper', 'tpLower' )
                }
            }
            return merge.filter( (value, index, self) => self.indexOf(value) === index )
        },
        [ jaw, setJaw ] = useState( getJawType(props).includes('upper')? 'tpUpper': 'tpLower' ),
        { AnimationReducer } = useSelector((state) => state),
        metas = AnimationReducer.metas,
        keyframe = AnimationReducer.keyframe.toLocaleString('en-US', {
            minimumIntegerDigits: 2,
            useGrouping: false
        }),
        getNumeric = ( sect ,special ,tooth, type ) => {
            let
                nb = '0.0',
                sector = (sect !== 'TOTAL') ? 'step_'+keyframe : 'totalAmount',
                container = metas.treatmentPlanning[jaw][sector]

            if ( container )
                if( container['toothID_'+tooth] )
                    if( container['toothID_'+tooth][type] )
                        if( container['toothID_'+tooth][type][special] )
                            nb = Number.parseFloat(container['toothID_'+tooth][type][special]).toFixed(2);

            return (nb !== '0.0' && nb !== '-0.0') ? nb : false
        },
        getTpJaw = jawId => {
            return {
                name: 'tp' + jawId.charAt(0).toUpperCase() + jawId.slice(1),
                TRANS: ( jawId === 'upper' )? 'SPE_MAXI': 'SPE_MAND'
            }
        },
        { att, ipr } = props,
        childProps = {
            att,
            ipr,
            getJawType,
            jaw,
            setJaw,
            getNumeric,
            getTpJaw,
            section,
            teeth: teeth,
            spe
        }

    return <IprAttDesktop {...childProps} />;
 }
